import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import {
  ClientStatusType,
  ClientStatusConfig,
  getClientStatusOptions,
} from "@/shared/types/clientStatus";

interface ClientStatusSelectProps {
  value: ClientStatusType | null | undefined;
  onValueChange: (value: ClientStatusType) => void;
  disabled?: boolean;
  className?: string;
}

export function ClientStatusSelect({
  value,
  onValueChange,
  disabled = false,
  className = "",
}: ClientStatusSelectProps) {
  const options = getClientStatusOptions();

  return (
    <Select
      value={value || undefined}
      onValueChange={(val) => onValueChange(val as ClientStatusType)}
      disabled={disabled}
    >
      <SelectTrigger className={`w-[200px] ${className}`}>
        <SelectValue placeholder="Set status..." />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => {
          const config = ClientStatusConfig[option.value];
          return (
            <SelectItem key={option.value} value={option.value}>
              <span className="flex items-center gap-2">
                <span className={`inline-block w-2 h-2 rounded-full ${config.dotColor}`} />
                {option.label}
              </span>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
